function updateHoveredOverlayId(editor) {
  if (editor.isDisposed) return false;
  const currentPagePoint = editor.inputs.getCurrentPagePoint();
  const margin = editor.getHitTestMargin();
  const overlay = editor.overlays.getOverlayAtPoint(currentPagePoint, margin);
  const previousOverlayId = editor.overlays.getHoveredOverlayId();
  if (overlay) {
    editor.overlays.setHoveredOverlay(overlay.id);
    editor.setHoveredShape(null);
    const util = editor.overlays.getOverlayUtil(overlay);
    const cursor = util.getCursor(overlay);
    if (cursor) {
      editor.setCursor({ type: cursor, rotation: editor.getSelectionRotation() });
    }
    return true;
  }
  if (previousOverlayId) {
    editor.setCursor({ type: "default", rotation: 0 });
  }
  editor.overlays.setHoveredOverlay(null);
  return false;
}
export {
  updateHoveredOverlayId
};
//# sourceMappingURL=updateHoveredOverlayId.mjs.map
